var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect, _rect2, _rect3, _polygon, _polygon2, _rect4, _path35, _rect5, _path36, _rect6, _path37, _rect7, _path38, _path39, _path40, _path41, _path42, _path43, _polygon3, _polygon4, _polygon5, _polygon6, _path44, _line, _line2, _line3, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _polyline, _path64, _line4, _line5, _path65, _line6, _line7, _path66, _path67;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M72.38,381.28q-3.5-3-6.75-6.12c1.67-.29,3.4-.65,5.15-1.1,1.23,1.14,2.49,2.26,3.77,3.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M445.57,309.33c-.84-3.59-2.15-7.45-3.5-11.42-.57-1.69-1.15-3.4-1.75-5.26-5.48-17,3.12-19.9,11.83-22.79,1.08-.36,2.17-.72,3.19-1.09a20.2,20.2,0,0,0,2.54-1.15,22.79,22.79,0,0,0,9.64-9.51c2.21-4.3,2.91-9.69.58-16a30.54,30.54,0,0,0-1.6-3.57c-1.61-3-3.27-5.83-4.77-8.37a86.53,86.53,0,0,1-4.61-8.39c-3.22-7.21-2.43-12.35,8.7-17.32a18.19,18.19,0,0,0,8.23-6.71,15.58,15.58,0,0,0,2.38-8.36,20.37,20.37,0,0,0-1.8-8.27,15.84,15.84,0,0,0-5.46-6.89c-3.55-2.26-5.87.45-8.58,3.63s-5.5,6.44-10.14,7.22l-1.92.31c-8.35,1.34-16.36,2.62-16.45,15.48a23.54,23.54,0,0,1-1.58,8.66,18.79,18.79,0,0,1-4.64,6.78C423,219,417.63,219,412.19,219c-4.2,0-8.45,0-11.29,1.23-11.49,5.08-8.79,16.15-6.12,27.06,1.34,5.5,2.68,11,2.32,15.77a11.77,11.77,0,0,1-1,4.21l-1.24-3.54c0-.26.07-.54.09-.83.33-4.49-1-9.78-2.26-15.1C389.8,236,386.88,224,400,218.23c3.24-1.43,7.73-1.42,12.16-1.41,5,0,9.94,0,12.2-2.08a16.57,16.57,0,0,0,4.1-6,21.35,21.35,0,0,0,1.43-7.86c.1-14.71,9-16.13,18.28-17.61l1.89-.31c3.87-.65,6.5-3.74,8.86-6.5,3.36-3.94,6.24-7.31,11.38-4a18,18,0,0,1,6.27,7.83,22.31,22.31,0,0,1,2,9.16,17.67,17.67,0,0,1-2.71,9.51,20.35,20.35,0,0,1-9.17,7.53c-9.52,4.25-10.26,8.52-7.61,14.46a85.24,85.24,0,0,0,4.5,8.17c1.51,2.55,3.17,5.35,4.82,8.46a31.85,31.85,0,0,1,1.72,3.84c2.57,6.94,1.77,12.93-.69,17.72a25.07,25.07,0,0,1-10.55,10.45,23.65,23.65,0,0,1-2.81,1.26c-1.09.4-2.18.76-3.26,1.12-7.67,2.55-15.26,5.06-10.44,20.07.54,1.67,1.14,3.46,1.74,5.23a121.13,121.13,0,0,1,3.67,12.12C447.06,309.33,446.32,309.32,445.57,309.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M405.35,295.55l61.8-122.15c-2.44-.37-4.37,1.9-6.56,4.46-2.6,3-5.5,6.44-10.14,7.22l-1.92.31c-8.35,1.34-16.36,2.62-16.45,15.48a23.54,23.54,0,0,1-1.58,8.66,18.79,18.79,0,0,1-4.64,6.78C423,219,417.63,219,412.19,219c-4.2,0-8.45,0-11.29,1.23-11.49,5.08-8.79,16.15-6.12,27.06,1.34,5.5,2.68,11,2.32,15.77a12,12,0,0,1-1,4.08c-.43-1.15-.86-2.3-1.3-3.44,0-.25.07-.52.09-.8.33-4.49-1-9.78-2.26-15.1C389.8,236,386.88,224,400,218.23c3.24-1.43,7.73-1.42,12.16-1.41,5,0,9.94,0,12.2-2.08a16.57,16.57,0,0,0,4.1-6,21.35,21.35,0,0,0,1.43-7.86c.1-14.71,9-16.13,18.28-17.61l1.89-.31c3.87-.65,6.5-3.74,8.86-6.5,3.07-3.59,5.73-6.7,10.19-4.69l1,.46-63.95,126.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M405.34,295.57v0l.87,3.07v0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M60.23,309.88c-3.19-6.09-1.22-14.08.89-22.67.37-1.53.76-3.09,1.11-4.66,3.05-13.3-3.92-15.54-11-17.81-1-.33-2.09-.67-3-1-.42-.16-.88-.34-1.37-.55a25.77,25.77,0,0,1-11.42-9.77,19.84,19.84,0,0,1-1.59-17.71c.19-.53.42-1.1.67-1.69,1.2-2.75,2.46-5.26,3.6-7.55,1-2,1.88-3.75,2.6-5.42,2.67-6.24,2.47-10.46-7.27-14.63a20.4,20.4,0,0,1-9.13-7.2,17.18,17.18,0,0,1-2.92-8.93A19.3,19.3,0,0,1,23,181.9a13.66,13.66,0,0,1,4.59-6c4.39-3,7.25.05,10.59,3.58,2.33,2.46,4.93,5.21,8.42,5.78l1.72.28c8.38,1.32,16.43,2.59,17.73,15.69a20.18,20.18,0,0,0,1.93,7,16.78,16.78,0,0,0,4.15,5.35c2.19,1.88,6.56,1.87,11,1.85,4,0,8,0,11,1.26,12.2,5.18,10.58,15.85,9,26.36-.72,4.74-1.43,9.45-.76,13.42.9,5.37,4.77,6,9.58,6.83,5.92,1,13.11,2.2,18.68,11.28A23.32,23.32,0,0,1,133,280l-1.49,3a21.82,21.82,0,0,0-2.78-7.32c-5.05-8.23-11.7-9.35-17.19-10.27-5.65-.95-10.2-1.72-11.35-8.61-.73-4.32,0-9.18.75-14.09,1.47-9.69,3-19.52-7.69-24.05-2.62-1.11-6.4-1.1-10.13-1.09-4.85,0-9.63,0-12.41-2.37a19,19,0,0,1-4.69-6,22.09,22.09,0,0,1-2.14-7.73C62.73,190,55.49,188.88,48,187.69l-1.74-.27c-4.2-.7-7.07-3.73-9.63-6.44s-4.94-5.21-7.82-3.26a11.52,11.52,0,0,0-3.81,5,17.13,17.13,0,0,0-1.36,7.47A15.15,15.15,0,0,0,26.15,198a18.26,18.26,0,0,0,8.19,6.42c11.43,4.9,11.63,9.95,8.41,17.46-.73,1.69-1.65,3.53-2.66,5.54-1.12,2.25-2.35,4.7-3.55,7.45-.21.5-.42,1-.61,1.56a17.75,17.75,0,0,0,1.39,15.86,23.62,23.62,0,0,0,10.44,8.91c.4.17.81.33,1.24.49,1,.37,2,.67,2.93,1,8,2.57,15.9,5.11,12.41,20.35-.36,1.57-.74,3.14-1.12,4.68-1.94,7.88-3.75,15.24-1.37,20.56a99.31,99.31,0,0,1,15.31.75,68.77,68.77,0,0,1,16.42,4.12,50.17,50.17,0,0,1,8.64,4.4,45.39,45.39,0,0,1,6.38,4.95h15.58c-.08.35-.16.67-.23,1a11.55,11.55,0,0,0-.21,1.2H108.17l-.74-.31a43.33,43.33,0,0,0-6.38-5,48.69,48.69,0,0,0-8.26-4.22,66.62,66.62,0,0,0-15.91-4,97.79,97.79,0,0,0-15.67-.71l-.67,0-.31-.6Zm70-3.91c.56.23,1.27.49,2.07.76l0-.15-2-1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M108.17,323.58a46.3,46.3,0,0,0-15-9.43c-25.13-10-57-1.39-57-1.39s-1.2,22.54,19.95,35.31a29.13,29.13,0,0,0,3.24,1.68c9.67-6.16,26.28-6,34-5.56l-5.09,9L105,323.58Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M95.33,340.66a151.75,151.75,0,0,1-16-2.9,98.74,98.74,0,0,1-32.95-14.12,1.38,1.38,0,0,1,1.55-2.29,96.17,96.17,0,0,0,32,13.72,150.63,150.63,0,0,0,16.87,3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M77.75,371.78C64.1,377.36,48.5,376.2,48.5,376.2a26.27,26.27,0,0,1,8.31-24.56c9-8.07,28.07-7.95,36.52-7.45Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M89.17,351.56a110.1,110.1,0,0,0-15.76,5.53A61.37,61.37,0,0,0,55,369.5a1,1,0,0,1-1.47,0,1.05,1.05,0,0,1,0-1.47,63.55,63.55,0,0,1,19-12.84A116.5,116.5,0,0,1,90.61,349Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M402.77,323.58a46.3,46.3,0,0,1,15-9.43c25.14-10,57.06-1.39,57.06-1.39s1.19,22.54-19.95,35.31c-6.36,3.83-14.72,5.27-23.33,5.41l-14.86-29.9Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M423.2,336.69c2.63-.46,5.23-1,7.82-1.62a96.12,96.12,0,0,0,32-13.72,1.39,1.39,0,0,1,1.56,2.29,98.83,98.83,0,0,1-32.95,14.12c-2.38.57-4.77,1.07-7.18,1.52h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M442,374.5a78,78,0,0,0,20.44,1.7,26.28,26.28,0,0,0-8.3-24.56,19,19,0,0,0-2.52-1.89c-5.83,2.58-12.87,3.61-20.08,3.73Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M430.92,352.22c2.54.89,5,1.87,7.47,3A63.3,63.3,0,0,1,457.44,368,1,1,0,1,1,456,369.5a61.33,61.33,0,0,0-18.43-12.41q-2.6-1.17-5.28-2.17Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M279.71,223.15c-7.61,13.2-19.51,30-23.71,36.85-11.58-2.47-29.22-5.68-44-8.6a18.25,18.25,0,0,1-4.27,5.85c-.5,1.82-1,3.68-1.34,5.46a33.7,33.7,0,0,0-.74,6c0,1.88,0,3.24,0,4.32l2.28,2.59.92,2.35c17.18,3.44,42.28,6.93,52.54,6.8a8.21,8.21,0,0,1,3.23-3.85,17.84,17.84,0,0,1,9.94-1.07,161.55,161.55,0,0,0,16-11.95C285,249.16,279.2,233.84,279.71,223.15Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M143.64,265.22a6.26,6.26,0,0,1,2.47-1.44c3.54-1.06,8.81-2.79,12.86-3.31,1.95.72,4.48,1.58,6.49,2.16-.05.87-.1,1.77-.16,2.64-.13,1.86,5.64,11.36,13.36,10.26,5.43-.78,5.25-5.62,5.16-10.16.77,0,9.73-.13,10.62.34,6.43,2.55,13.32,9.38,13.32,9.38L219,303.93c-2.63,4.89-16.36,9.71-22,8.49-.22,4.15-.34,7.4-.31,11.21H141.15"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M215.42,307.55a43.59,43.59,0,0,0,.78,4.65c.58,2,5.39,8.16,8,11.38H204.65a54.19,54.19,0,0,1-3.8-6.08,21.41,21.41,0,0,1-1.31-5.83C203.54,312.12,210.48,310.24,215.42,307.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M406.22,311.16c.35,3.08.63,6,.83,8.85"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M324.71,193.91l-.48.32.48-.32Zm-.5.34-.06,0,0,0h0l-.05,0,0,0,.2.15Zm-.6-.45,0,0-.05,0,0,0,.1.08Zm-.29-.23h0l0,0h0l.06,0Zm-1.8-1.59-.09-.08.18.17-.09-.09Zm-27.93,86.54c-6.52-24.36-15-44-13.79-56.63a41.6,41.6,0,0,1,2.84-4.39H284l.38,0H286l.3,0H287l.14,0h.16l.15,0h.15l.14,0,.15,0h.15l.25,0h.2l.15,0,.14,0h0l.15,0,.14,0h.15l.3,0h.15l.15,0,.15,0h0l.27,0,.14,0h0l.3-.05.11,0h0l.3-.05h.15l.15,0,.15,0h0l.12,0,.15,0,.14,0A6.23,6.23,0,0,1,292,219c-4.86,16.6,25.31,6.43,31.55-12.34a13.07,13.07,0,0,0,.42-7.13,12.33,12.33,0,0,0,.88-5.77,23.91,23.91,0,0,0,5.16-4.87,13.3,13.3,0,0,1,2.35-.27c46.64,21.29,63.69,72,76.47,119.61a75.89,75.89,0,0,1-16.79,15.33m-91.48,0a158.64,158.64,0,0,0-1.55-18.92"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M329.77,189.27a13.54,13.54,0,0,1,2.16-.26l0,.14a115.25,115.25,0,0,0-9.06,19.73l-.07-.19c.28-.66.55-1.33.77-2a13.07,13.07,0,0,0,.42-7.13,12.33,12.33,0,0,0,.88-5.77,24.11,24.11,0,0,0,4.88-4.51Zm-5.06,4.64-.48.32Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M313.67,266.05A151.48,151.48,0,0,1,302.8,252c-3.74-5.49-7.45-11.86-9.27-17.65-4.44-14.14-2.68-17.37-2.68-17.37l.08-.24a64,64,0,0,1-8.93.77c-.32,4.64-.3,8.62-.3,8.62,3-.31,8.68,1.69,10.51,3.65,1,2.21-6.25,12.6-6.25,12.6s13.26,14.7,17,17.58A73.21,73.21,0,0,0,313.67,266.05Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M331.31,309.61c-1-2.29-2-4.69-3-7.12M317.1,275c-1.74-4.35-3.05-7.67-3.66-9.21"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M289.12,298.36l-4.7-.19c-2.43-.11-.37,2.85-2.19,4.46-4.28,3.76-12.41,3.95-18.39.87-.75-.39-4.23,6-5,7.18s-3.78,2.72-3.28-1.19,3.27-25.82,9.11-28.61,14.16-.49,16.57.88c1.63.92,1.1,1.49,2.11,1.85a24.23,24.23,0,0,0,5.66.73A52.31,52.31,0,0,0,289.12,298.36Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M299.3,235a36.84,36.84,0,0,0,3,6.13c1.17,1.44,4.37-.3,4.37-.3l1.39-7c-2.47-.83-5.08-2.26-5.86-3.92,0,.22,0,.43.05.63a2,2,0,0,1-.08.62A10.56,10.56,0,0,1,299.3,235Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M301.79,226.71c.21,1.26.42,2.7.5,3.85a2,2,0,0,1-.08.62c-.78,2.77-7.1,7.33-7.1,7.33A65.68,65.68,0,0,1,291,223.82c0-.34-.79-4.38-.09-7.08l1.18-.2A6.23,6.23,0,0,1,292,219C289.81,226.64,295,228.61,301.79,226.71Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M312,234.66c3.66,0,3.67,0,3.67,0l8-28h0c-3.39,10.2-13.86,17.87-21.92,20.06l.4,2.73c.73,2.89,7.28,5.19,9.9,5.19Zm12-29.23,0-.15v0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M292.11,216.54A6.23,6.23,0,0,1,292,219c-4.86,16.6,25.31,6.43,31.55-12.34a13.07,13.07,0,0,0,.42-7.13,12.33,12.33,0,0,0,.88-5.77l-.68.47a24.72,24.72,0,0,1-5.53-5.56l-.41-.75-.08,0a22,22,0,0,1-3.71-10c3.46-2.37,6-4.48,7.7-6.84,6-8.6-7.32-34.71-21.44-11.06a28.82,28.82,0,0,1-12.07-10.9c-8.86,6.7-26.19,17.18-49,18.32l.09.15.09.15.09.15.09.14.1.15.09.14.09.14h0l.1.15.15.23h0l0,.05.1.14.1.15.09.13h0l.1.14.1.15h0l.09.13.1.14.08.12,0,0,.1.14.1.14,0,.08.05.06.1.15.1.14.11.14.1.14.1.14h0l0,0,.19.24.07.1,0,.05.22.28,0,0,.06.09.19.24,0,0h0l.1.12.17.22,0,0,0,0,0,0,.25.31h0l.05.06.23.28,0,0,.08.1.23.28h0l.12.14.11.14,0,0,.09.1.12.14.11.14.12.13.12.14.12.14h0l0,0,.28.31,0,0,0,0,.12.13.12.14.07.08.05.05.12.14.12.14,0,0,.09.1.12.14.12.13.1.1.07.09h0l.09.1,0,.07,0,0,.09.11,0,0,0,.06.09.1,0,0,0,0,.11.13v0h0l.07.1.07.09h0l.08.1.05.07,0,0,.08.1,0,0,0,.05.08.1,0,.08,0,0,.07.1h0v0l.1.13v0h0l.06.1,0,.08,0,0,.06.1,0,.06,0,0,.06.11,0,0,0,.06.06.1,0,0,.1.18h0l.09.15,0,0h0l.06.1,0,.07v0l.06.1,0,0,0,.05.05.11,0,0,0,.07,0,.11h0l0,.1,0,.09h0l.05.11,0,.08v0l0,.1,0,.06,0,.05,0,.11,0,0,0,.07,0,.11v0l0,.09,0,.11h0l0,.11,0,.09v0l0,.11,0,.07v0l0,.12,0,.1h0l0,.12v0l0,.08,0,.12h0l0,.1,0,.11h0l0,.12,0,.08v0l0,.11,0,.07v0a68.16,68.16,0,0,1,1.34,7.63c1.32,9.33,4.08,20.11,16.3,24.59C274.5,217.86,283.31,218.07,292.11,216.54Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M302.8,252s5.85,8,7.33,9.84,3.38,4.14,3.38,4.14-.76-7-.69-9.47.38-6.84.38-6.84l-6.49-8.82c-.82.56-3.19,1.46-4.42.43Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M141.11,322.55H326.66l1.36,2.14-186.91,0v-2.16Zm250.56,0,1.72,2.14H416l30.67,61.69H70.75l34.85-61.68H124V322.5h-19.6l-37.3,66H450.17q-16.41-33-32.82-66Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M128.86,305.19c-1.7,6.07-4.05,14.55-4.91,18.28-1.41,6.13,1.48,14.69,15.26,16.83s16.08,4.47,16.08,4.47-.82,5.75,5.54,5.69,6.62-1.39,8.91.41,7.09-.25,8.34-3.47c1.65-4.28-1.78-7.07-4.3-8.26A19,19,0,0,0,169,337.8a2.36,2.36,0,0,0,.7-.39c2.12-1.81-5.79-2.25-9.68-.23-1.9-.26-20.69-9-20.37-9.41,0,0,4.06-11.16,6-18.91a19.7,19.7,0,0,1-4.87,0c-3.67-.49-10.77-2.61-11.77-3.5Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M144.47,264.59c-10.27,7.52-16.21,25.89-18.58,36.8-.09,4.62,17.08,10.51,24.76,5.9.12-6.82,1.56-15.68,3-23"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M165.46,262.63c-.05.87-.1,1.77-.16,2.64-.13,1.86,5.64,11.36,13.36,10.26,5.43-.78,5.25-5.62,5.16-10.16,1.13,0,2.26,0,3.39-.13,12.85-.92,22.64-7.11,25.35-15.19,2.31-6.88.29-10.06-1.2-14.28h0c1-.06,2.25-3.22,2.73-6.29l0-.13c.06-.44.11-.88.15-1.3v0l0-.5h0v-.48h0v-.69h0v-.23l0-.14v-.28l0-.14v-.06l0-.14,0-.09,0-.12v0h0v0l0-.14,0-.05s0-.09-.05-.13h0v0l-.06-.14h0l-.06-.13v0a1.25,1.25,0,0,0-.08-.12h0l-.09-.11v0l-.08-.09,0,0-.09-.08h0l-.1-.08h0l-.1-.07h0l-.11-.05h0l-.13,0h0l-.15,0a4.86,4.86,0,0,0-2.3.56h0l0-.37h0l.06-.38.06-.38h0l.07-.39v-.16l0-.08v-.08l0-.08h0v-.08l0-.08v-.08l0-.08v-.07h0l0-.08v-.08l0-.08v-.08l0-.08v-.08l0-.08v-.08l0-.08,0-.08V221l0-.09v-.08l0-.08v-.16l0-.08,0-.08v-.16l0-.08,0-.08v-.08l0-.08v-.08l0-.09v-.08l0-.08,0-.08v-.16l0-.08,0-.08,0-.08v0l0-.05V219l0-.08,0-.08,0-.08v0l0-.05,0-.08,0-.08v-.08l0-.08v-.08l0-.08,0-.16,0-.08h0l0-.07,0-.08v-.08l0-.08,0-.08h0l0-.08.16-.67v0c.1-.38.19-.76.29-1.14l0-.06,0-.08,0-.16,0-.07h0l.12-.48,0-.07,0-.16v0l0-.06,0-.16,0-.07,0-.07,0-.09,0-.07,0-.08,0-.08,0,0v0l0-.08,0-.08,0-.07,0-.08h0v-.06l0-.08,0-.07,0-.08,0-.06h0l0-.07,0-.08,0-.07.09-.29,0-.07c-13.94,6.51-40.14,5.07-47-.36-1.67-1.31-2.25-3.14-.75-5.79a5.44,5.44,0,0,0,1.23-3.58c-2,2.63-5.32,8.62-10,6.59-5.44-.34-3.83,17-3.83,17-5.24-7.91-9.91-6.75-12.64-2.87-5.3,7.52-1.43,20.34,8.49,21,0,0,3.63,9.9,3,12.88A93.34,93.34,0,0,0,165.46,262.63Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M165.41,206.39a5.44,5.44,0,0,0,1.23-3.58c-2,2.63-5.32,8.62-10,6.59-5.44-.34-3.83,17-3.83,17-5.24-7.91-9.91-6.75-12.64-2.87-5.3,7.52-1.43,20.34,8.49,21,0,0,3.63,9.9,3,12.88-7.21.77-24.34-16.5-26.57-27.84-3.25-6.82-9-32.83-1.06-48.16,2.57-5,8.08-8.77,12.41-7.47,7.58-10.21,21.6-18.59,47.8-16,12.76.32,28.59,8.4,35.78,18,3.57,4.76,4.12,8.85-3.73,8.65A34.77,34.77,0,0,1,222,200a10.65,10.65,0,0,1-.07,3.1c.28,3.77.35,10-1.45,15.54a32.31,32.31,0,0,1-6.36,10.83c.44-2.84.25-5.61-1.3-5.75a4.86,4.86,0,0,0-2.3.56h0l0-.37v0l.06-.38.06-.38h0l.07-.39c.29-1.71.67-3.46,1.08-5.15h0c.43-1.78.91-3.5,1.36-5-13.94,6.51-40.14,5.07-47-.36C164.49,210.87,163.91,209,165.41,206.39Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M191,240.52a1.39,1.39,0,0,1-2.58-1,6.31,6.31,0,0,1,4-3.84,5.36,5.36,0,0,1,2.5-.18,4.65,4.65,0,0,1,2.23,1h0a4.38,4.38,0,0,1,1.48,3.68,1.39,1.39,0,1,1-2.77-.16,1.65,1.65,0,0,0-.53-1.41,1.79,1.79,0,0,0-.89-.41,2.51,2.51,0,0,0-1.21.09A3.55,3.55,0,0,0,191,240.52Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M288.67,149.15a28.82,28.82,0,0,0,12.07,10.9c14.12-23.65,27.46,2.46,21.44,11.06-1.65,2.36-4.24,4.47-7.7,6.84a23.65,23.65,0,0,0,9.73,16.3c12.94-8.4,14.62-26.79,13.91-46.9-.66-18.53-16.53-40.11-32.08-37.92-.92.13-1.85.3-2.79.49a20.08,20.08,0,0,0-10.62-7.1c-14.07-4.33-23.18.78-35.39,8.9-3.24,2.16-8.55,3.24-14.53,4.43-35.71,7.08-29.05,43.48-12.93,50.32,4.36,8.8,13.95,13.81,20.46,16.76a15.15,15.15,0,0,0-3.69-6.77,57.41,57.41,0,0,1-6.88-9C262.48,166.33,279.81,155.85,288.67,149.15Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M263.58,192.89a1.39,1.39,0,1,1-2.62.91,4.09,4.09,0,0,1,.43-3.71,5.22,5.22,0,0,1,2-1.73,6.17,6.17,0,0,1,2.55-.69,5.35,5.35,0,0,1,4.38,1.86,1.38,1.38,0,1,1-2.1,1.79,2.63,2.63,0,0,0-2.16-.88,3.63,3.63,0,0,0-1.39.37,2.53,2.53,0,0,0-.91.79A1.38,1.38,0,0,0,263.58,192.89Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M328,244.39a150.18,150.18,0,0,0,.65,29c-6.25.6-30.58,4.94-38.26,5.5-2.33,4.16-2.91,22.52,1.44,26.1,0,0,44.55-1.34,50.86-5.67s19.51-59.54,18.44-69.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 382.03,
    height: 12.27,
    x: 67.62,
    y: 387.44,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76,
    height: 23.19,
    x: 140.41,
    y: 342.84,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(-69.05 142.763 354.417)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.86,
    height: 23.19,
    x: 141.86,
    y: 342.84,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(-69.05 142.785 354.432)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "161.08 361.44 152.77 360.8 154.47 356.36 161.08 361.44"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "161.08 361.44 157.44 361.16 158.19 359.21 161.08 361.44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76,
    height: 0.93,
    x: 129.15,
    y: 349.65,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(-69.05 131.499 350.106)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M127.39,349.56l.68-1.78a1.44,1.44,0,0,1,1.85-.82l2,.77-1.7,4.44-2-.77A1.43,1.43,0,0,1,127.39,349.56Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.05,
    height: 7.7,
    x: 114.62,
    y: 350.94,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    transform: "rotate(-38.14 118.13 354.785)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M123.29,355.65,117.75,360l1.19,1.51a.61.61,0,0,0,.86.11l4.58-3.59a.63.63,0,0,0,.1-.87Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.02,
    height: 7.7,
    x: 116.13,
    y: 351.77,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    transform: "rotate(-38.15 117.115 355.59)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M313.67,266.05c-4.32-19.11,8.12-60.77,18.62-77.46,5.56,2.26,7.51,12.58,10.19,18-6.93,4.7-19.08,14.16-24.72,20.58,2.29,3.25,7.19,8,9.47,11.26Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 336.79,
    height: 17.62,
    x: 90.24,
    y: 399.74,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M121.93,82.64h75.64a3.29,3.29,0,0,1,3.28,3.28v42.19h0v16.15c0,.82-.13,1.71-1.07.65l-14.45-13.69h-63.4a3.28,3.28,0,0,1-3.27-3.28v-42A3.29,3.29,0,0,1,121.93,82.64Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M126.38,94.23a2.09,2.09,0,1,1,0-4.17H173.6a2.09,2.09,0,0,1,0,4.17Zm54.67,0a2.09,2.09,0,1,1,0-4.17h12.3a2.09,2.09,0,1,1,0,4.17Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M126.38,104.17a2.09,2.09,0,1,1,0-4.17h30a2.09,2.09,0,0,1,0,4.17Zm37.5,0a2.09,2.09,0,1,1,0-4.17h29.47a2.09,2.09,0,1,1,0,4.17Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M126.38,114.1a2.09,2.09,0,1,1,0-4.17h67a2.09,2.09,0,1,1,0,4.17Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M126.38,123.39a2.09,2.09,0,1,1,0-4.17h35.07a2.09,2.09,0,0,1,0,4.17Zm44.56,0a2.09,2.09,0,1,1,0-4.17h22.41a2.09,2.09,0,1,1,0,4.17Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M195.69,360.93l-1.31,3.4.23,2.36,53.83,9.72v.6a.35.35,0,0,0,.35.34h4.06a.34.34,0,0,0,.34-.34v-.63L311,364.89l.11-4.28L308.62,356l-57.44,12.22,57.08-12.14.69,4.82-58,12.71-55.18-10.15Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "195.61 358.15 195.76 363.45 250.94 373.6 308.95 360.89 308.26 356.07 251.18 368.21 195.61 358.15"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "205.67 327.11 250.22 334.9 287.87 325.16 310.02 355.69 251.18 368.21 194.42 357.94 205.67 327.11"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "249.89 334.85 250.22 334.9 287.87 325.16 310.02 355.69 251.34 368.18 249.89 334.85"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "203.99 343.13 198.8 355.89 248.82 365.63 248.3 350.91 203.99 343.13"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M206,343.47a13.67,13.67,0,0,0,3.87,7c3.64,3.32,13.68-1.31,18.11,2s4.63,6.84,11.47,4a22.79,22.79,0,0,0,8.44-5.6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 205.85,
    x2: 247.91,
    y1: 339.18,
    y2: 347.3,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 207.21,
    x2: 247.34,
    y1: 335.4,
    y2: 343.3,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 209.29,
    x2: 246.95,
    y1: 331.63,
    y2: 339.46,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M254.61,363.59a.52.52,0,0,1-.22-1l49.15-10.83a.52.52,0,0,1,.62.4.52.52,0,0,1-.39.62Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M254.62,359.66a.52.52,0,0,1-.22-1l45.12-9.93a.52.52,0,1,1,.22,1Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M254,355.4a.51.51,0,0,1-.62-.39.52.52,0,0,1,.39-.62l43.46-9.57a.52.52,0,0,1,.62.4.52.52,0,0,1-.4.62Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M253,351.39a.52.52,0,0,1-.63-.39.52.52,0,0,1,.39-.62l41.54-9.59a.52.52,0,1,1,.23,1Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M253.14,347.31a.52.52,0,0,1-.63-.38.5.5,0,0,1,.38-.62l38.34-9.39a.52.52,0,0,1,.62.39.51.51,0,0,1-.38.62Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M252.78,343.29a.52.52,0,0,1-.63-.38.53.53,0,0,1,.39-.63l36.61-8.88a.53.53,0,0,1,.63.39.51.51,0,0,1-.39.62Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M252.61,339.41a.52.52,0,1,1-.25-1l34.47-8.71a.52.52,0,1,1,.25,1Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M205.42,351.47a2,2,0,1,1-2,2A2,2,0,0,1,205.42,351.47Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M416.83,164.91a1,1,0,0,1,0,2.09H386.28a1,1,0,1,1,0-2.09Zm-35.38,0a1,1,0,1,1,0,2.09h-8a1,1,0,0,1,0-2.09Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M416.83,171.34a1,1,0,0,1,0,2.09h-19.4a1,1,0,0,1,0-2.09Zm-24.26,0a1,1,0,0,1,0,2.09H373.49a1,1,0,0,1,0-2.09Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M416.83,177.77a1,1,0,1,1,0,2.08H373.49a1,1,0,0,1,0-2.08Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M416.83,183.77a1,1,0,0,1,0,2.09H394.14a1,1,0,1,1,0-2.09Zm-28.83,0a1,1,0,0,1,0,2.09H373.49a1,1,0,0,1,0-2.09Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M328.93,339.6c-2.56.07-2.79.06-2,1.16,6,8.49,10.71,18.65,16.29,27.58,2.93,4.68,2.26,4,7.79,3.85,14.07-.31,27.8-1.71,41.87-2,3.54-.08,4.34,0,3.35-1.43a2.43,2.43,0,0,1,0-.27c0-1.53.13-4.59,0-5.65.53-.18.45-.55-.11-1.33m-63.79-28.75-3.05.08c-3.6.09-3,.05-1,3.14l2.25,3.6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M328.76,336.75v4.34l17.52,29.17,48.36-1.8.11-5.48-1.88,0c-15.13.32-30.49,1.63-45.78,2.14C345.74,364.56,331.25,340.25,328.76,336.75Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M332.36,332.74c.09.09-.71,2.62-.47,3,5.18,8.3,9.47,15.56,14.66,23.86,2.93,4.69,3.4,4,8.93,3.91,14.07-.31,27.8-1.71,41.87-2,4.53-.1,4.58.06,2.12-3m-3.24-4.1,1.12,0c4.93-.11,4.55.09,1.39-3.93-.77-1-1.54-2-2.31-2.93"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M352,361.45l47.32-2V354.3l-2,.05c-14.07.3-27.43,1-41.5,1.27-1.26,0-2.19.08-2.93.1h-.31a.77.77,0,0,0-.76.84c0,.65-.09,2.9-.14,4.32C351.7,361.2,351.76,361.42,352,361.45Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M393.89,347.66l0,1.86-47.72,1.69L328,322.14v-1.48c-3,.09-2.32.21-.49,3.13,5.19,8.3,9.74,17.3,14.93,25.6,2.93,4.68,2.27,4,7.8,3.85,14.07-.3,27.8-1.71,41.87-2,3.53-.08,4.34,0,3.34-1.43v-.28c0-.5,0-1.16.05-1.86m-67-33.79c-3.6.1-3,.06-1,3.15l.94,1.5,7.25,11.6.6,1,.49.77.07.13.53.84.34.54.12.19.33.53.09.15.9,1.43,0,.06.68,1.1.33.53,2.26,3.61.33.53c2.46,3.94,3.94,6.53,7.14,6.4l1.27,0m-21.47-27.24,5.95,9.51Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M398.76,342.92c1.15,1.35,1.2,4.52.85,4.53l-48.07.92L327.48,312h4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M350.06,340.84c2.93,4.69,2.27,4,7.8,3.85,14.06-.3,25.63-1.65,39.69-2,4.59-.1,4.58.07,2-3.14"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "354.56 342.59 399.56 340.68 399.56 335.11"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M350.25,341.07l-18.77-28.63-.07-6.48h0c-.1-.52.6-.53,2.58-.58l39.12-1.05c3.4-.09,3.76-.39,5.76,2.16,6.81,8.67,13.26,16.5,20.08,25.17,3.16,4,3.54,3.82-1.4,3.93-14.06.3-27.42,1-41.49,1.27-1.26,0-2.2.08-2.93.1h-.32a.78.78,0,0,0-.76.84"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 328.21,
    x2: 327.98,
    y1: 318.17,
    y2: 322.14,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 332.83,
    x2: 351.36,
    y1: 306.76,
    y2: 335.37,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M352.05,337.81a27.56,27.56,0,0,0,.3,4.29c.27.71,2.91.46,2.91.46"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 349.94,
    x2: 351.29,
    y1: 353.25,
    y2: 354.77,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 347.25,
    x2: 346.92,
    y1: 365.69,
    y2: 369.78,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M116.31,324.14l-88.8-148.3,1.08-.51c3.88-1.82,6.51,1,9.55,4.17,2.33,2.46,4.93,5.21,8.42,5.78l1.72.28c8.38,1.32,16.43,2.59,17.73,15.69a20.18,20.18,0,0,0,1.93,7,16.78,16.78,0,0,0,4.15,5.35c2.19,1.88,6.56,1.87,11,1.85,4,0,8,0,11,1.26,12.2,5.18,10.58,15.85,9,26.36-.72,4.74-1.43,9.45-.76,13.42.9,5.37,4.77,6,9.58,6.83s10.75,1.81,15.77,7.36l-1,2.11c-4.71-5.59-10.34-6.54-15.09-7.34-5.65-.95-10.2-1.72-11.35-8.61-.73-4.32,0-9.18.75-14.09,1.47-9.69,3-19.52-7.69-24.05-2.62-1.11-6.4-1.1-10.13-1.09-4.85,0-9.63,0-12.41-2.37a19,19,0,0,1-4.69-6,22.09,22.09,0,0,1-2.14-7.73C62.73,190,55.49,188.88,48,187.69l-1.74-.27c-4.2-.7-7.07-3.73-9.63-6.44-2.06-2.17-3.89-4.1-5.88-4L117.85,322.5h6.33c-.08.35-.16.67-.23,1a11.55,11.55,0,0,0-.21,1.2h-7.11l-.32-.53ZM130.19,306l.06-.37,2,1,0,.15C131.46,306.46,130.75,306.2,130.19,306Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M419.7,159.8H370.76a2.14,2.14,0,0,0-2.12,2.13v27.29h0v10.45c0,.54.08,1.11.69.42l9.36-8.85h41a2.14,2.14,0,0,0,2.13-2.12V161.93A2.14,2.14,0,0,0,419.7,159.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.040a84fc1c1c8089d89af935ef7dda3c.svg";
export { ForwardRef as ReactComponent };